<template>
  <VModal name="user-reset-password-modal">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('users.resetPassword') }}</h2>
    </template>
    <template v-slot:content>
      <i18n path="users.resetPasswordWarning" tag="p">
        <template v-slot:userName>
          <span><b>{{ user.name }}</b></span>
        </template>
        <template v-slot:userEmail>
          <span><b>{{ user.email }}</b></span>
        </template>
      </i18n>
      <VForm>
        <div slot="formButtons" type="left">
          <VButton
              type="outline-1"
              :action="modalBack"
              data-ec="users_reset_password_modal"
              data-et="cancel_button">
            <span>{{ $t('functional.cancel') }}</span>
          </VButton>
        </div>
        <div slot="formButtons" type="right">
          <VButton
              type="warning"
              :action="resetPassword"
              :loading="loading"
              data-ec="users_reset_password_modal"
              data-et="reset_password_button">
            <ExclamationTriangleIcon />
            <span>{{ $t('users.resetPassword') }}</span>
          </VButton>
        </div>
      </VForm>
    </template>
  </VModal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import { ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'ResetUserPasswordModal',
  props: {
    user: {
      type: [Object],
      required: true,
    },
  },
  components: {
    VButton,
    VForm,
    VModal,
    ExclamationTriangleIcon,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    modalBack() {
      this.$emit('cancel');
      this.$bus.$emit('closeModal');
    },
    resetPassword() {
      this.loading = true;
      this.$store.dispatch('users/RESET_USER_PASSWORD', { user: this.user }).then(() => {
        this.$bus.$emit('closeModal');
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
